import React from 'react';

interface LinkButtonProps {
  href?: string;
  title?: string;
  className?: string;
  modifiers?: string;
  target?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const LinkButton = (props: LinkButtonProps) => (
  <a
    href={props.href}
    title={props.title}
    aria-label={props.title}
    data-wx-button={props.modifiers}
    onClick={props.onClick}
    className={props.className}
    target={props.target}
  >
    {props.children}
  </a>
);

export default LinkButton;
